import React from "react";
import useViewerContext from "./use-viewer-context.ts";
import ViewerLoading from "@/components/viewer-loading";
import ViewerError from "@/components/viewer-error";

export interface ViewerCanvasProps {
    className?: string;
    showLoading?: boolean;
    loadingText?: string;
    children?: React.ReactNode;
}

export const ViewerCanvas: React.FC<ViewerCanvasProps> = ({
    className = "w-full h-full overflow-hidden",
    showLoading = true,
    loadingText,
    children,
}) => {
    const { setContainer, isLoading, loadingProgress, error, retry } = useViewerContext();

    return (
        <div className="relative w-full h-full" aria-busy={isLoading && !error}>
            <div ref={setContainer} className={className} />
            {showLoading && isLoading && !error && (
                <ViewerLoading progress={loadingProgress} loadingText={loadingText} />
            )}
            {children}
            <ViewerError error={error} retry={retry} />
        </div>
    );
};

export default ViewerCanvas;
